import type { DataTableColumn } from "mantine-datatable";
import { getYearString } from "../../helpers/stringHelper";
import { occupationTranslations } from "../../models/enums/occupation";
import { reportTypeTranslations } from "../../models/enums/reportType";
import type { ReportConfiguration } from "../../models/reportConfigs/reportConfiguration";
import { DataTable, type DataTableProps } from "../datatable/DataTable";

type ReportConfigsTableProps = {
  reportConfigs: ReportConfiguration[];
} & Required<
  Pick<
    DataTableProps<ReportConfiguration>,
    "onEdit" | "onDelete" | "onSortStatusChange" | "sortStatus" | "onDuplicate" | "pagination" | "onPageChange" | "fetching"
  >
>;

export function ReportConfigsTable({ reportConfigs, ...props }: ReportConfigsTableProps) {
  const columns: DataTableColumn<ReportConfiguration>[] = [
    {
      accessor: "title",
      title: "Titel",
      sortable: true,
    },
    {
      accessor: "report_type",
      title: "Typ",
      sortable: true,
      render: (reportConfig) => reportTypeTranslations[reportConfig.report_type],
    },
    {
      accessor: "year_context",
      title: "Jahrgang",
      sortable: true,
      render: (reportConfig) => getYearString(reportConfig.year_context),
    },
    {
      accessor: "occupation",
      title: "Beruf",
      sortable: true,
      render: (reportConfig) => (reportConfig.occupation ? occupationTranslations[reportConfig.occupation] : "-"),
    },
    {
      accessor: "group.name",
      title: "Gruppe",
      sortable: true,
      render: (reportConfig) => (reportConfig.group ? reportConfig.group.name : "-"),
    },
  ];

  const canDelete = (reportConfigs: ReportConfiguration) => reportConfigs.deletable;

  return <DataTable columns={columns} records={reportConfigs} canDelete={canDelete} {...props} />;
}
